import Button from "../../design-system/components/Button/Button.jsx";
import { MODELS, useModel } from "../../api";
import { ROUTES } from "../../routes.js";
import { styles } from "./notFoundPage.css.ts";

/**
 * "Not Found" page with error text and navigation button.
 * Displays a centered error message and return button.
 */
const NotFoundPage = () => {
  const currentUser = useModel(MODELS.ME);

  return (
    <div className={styles.container}>
      <p className={styles.text}>
        Hier gab es einen Fehler! Die Seite, die du aufrufen wolltest, konnten
        wir leider nicht finden!
      </p>
      {currentUser ? (
        <Button width="fit" to={ROUTES.lernreisenOverview.getUrl()}>
          Hier kommst du zurück zur Übersicht deiner Lernreisen!
        </Button>
      ) : (
        <Button width="fit" to={ROUTES.login.getUrl()}>
          Zurück zur Startseite
        </Button>
      )}
    </div>
  );
};

export default NotFoundPage;
